import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InfoIcon from 'assets/icons/info-icon.svg?react';
import DesoResidentTransmitterImage from 'assets/images/deso-resident-transmitter.png';
import G2TransmitterImage from 'assets/images/g2-transmitter.png';
import { DeviceType } from 'shared/models/device-type';

import useDeviceInfoModal from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/device-info-modal/hooks/use-device-info-modal';
import styles from './device-info-modal.module.scss';

type Props = {
  type: DeviceType;
  displayType?: string;
};

const DeviceInfoModal = ({ type, displayType }: Props): React.JSX.Element => {
  const { t } = useTranslation('deviceTypes');
  const { isPopupOpen, handleOpenPopup } = useDeviceInfoModal();

  const renderDeviceImage = (deviceType: DeviceType): ReactElement => {
    switch (deviceType) {
      case DeviceType.G1:
      case DeviceType.G2:
      case DeviceType.G2Transmitter:
        return <img src={G2TransmitterImage} alt="G2 Transmitter" />;
      case DeviceType.DesoClient:
      case DeviceType.DesoResidentTransmitter:
        return <img src={DesoResidentTransmitterImage} alt="Deso Resident Transmitter" />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <InfoIcon
        className={styles.deviceInfoIcon}
        onClick={(e) => {
          e.stopPropagation();
          handleOpenPopup(true);
        }}
      />

      <Dialog open={isPopupOpen} onClose={() => handleOpenPopup(false)} slotProps={{ paper: { classes: { root: styles.modalPaper } } }}>
        <div className={styles.deviceInfoModalContainer}>
          <div className={styles.deviceInfoModalHeader}>
            <Typography variant="h3">{displayType ?? t(type)}</Typography>
            <IconButton
              aria-label="close"
              className={styles.closeButton}
              onClick={(e) => {
                e.stopPropagation();
                handleOpenPopup(false);
              }}
            >
              <Close />
            </IconButton>
          </div>
          <div className={styles.deviceImageContainer}>{renderDeviceImage(type)}</div>
        </div>
      </Dialog>
    </>
  );
};

export default DeviceInfoModal;
